var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('VueTwitchPlayer',{attrs:{"height":"290","channel":_vm.stream_info.channel_name}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }